import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('costos-programas'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('costos-programas'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`costos-programas/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`costos-programas/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`costos-programas/${id}`));
  },
};
